import { blue20opacity20, blue90 } from '../../../colors/blue';
import { black, gray20, gray75 } from '../../../colors/gray';
import { red01 } from '../../../colors/red';
import { yellow01 } from '../../../colors/yellow';
export var MuiBadge = {
    styleOverrides: {
        badge: {
            color: blue90,
            borderColor: gray75,
        },
        colorError: {
            color: black,
            backgroundColor: red01,
        },
        colorSecondary: {
            color: gray20,
            backgroundColor: blue20opacity20,
        },
        colorWarning: {
            backgroundColor: yellow01,
        },
    },
};
